export const TABS = {
  ABOUT_ME: 0,
  SKILLS: 1,
  PROJECTS: 2,
  CONTACT: 3,
};
